import { useState } from "react";
import { UiComponents, PasswordKey } from "@simulanisindia/ui";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { EditIcon } from "../../assets/Icons";
import { InfoIcon } from "../../Icons";
import { useModalContext } from "../../modal/context/ModalProvider";
import { checkPermissionExist, getPlaceholderName, modalName } from "../../utils/general";
import { toolTip } from "../Tooltips/CustomTooltip";
import { PASSWORD_CHANGE_PERMISSION } from "../../constant/permission";

const { SimToggleSwitch } = UiComponents;

const UserInfoPanel = ({ userDetails, UUID, params, isMobileView }) => {
  const navigate = useNavigate();
  const { openModal } = useModalContext();
  const [imageError, setImageError] = useState(false);

  const handleOpenChangePasswordModal = () => {
    openModal({
      modalName: modalName.PASSWORD_CHANGE,
      type: "update",
      UUID: UUID,
      params,
      user: {
        email: userDetails.email,
      },
    });
  };

  const handleOpenEditProfileModal = () => {
    navigate(`/manage/account/${UUID}`);
    // openModal({
    //     modalName: modalName.USER_ADD,
    //     type: "update",
    //     id: userDetails?.uuid,
    //     params,
    //     handleRefreshTab: getUserDetails,
    //     openChangePasswordModal: handleOpenChangePasswordModal
    // })
  };

  const avatarSrc = userDetails?.avatar;
  const userName = userDetails?.name;

  return (
    <>
      {!isMobileView ? (
        <div className="parent-group">
          <div className="group-function-parent">
            <div className="group-info">
              <div className="profile for-user">
                <div className="bg">
                  {avatarSrc && !imageError ? (
                    <img
                      src={avatarSrc}
                      referrerPolicy="no-referrer"
                      onError={() => setImageError(true)}
                      alt="avatar"
                    />
                  ) : (
                    <span className="initials">{getPlaceholderName(userName)}</span>
                  )}
                </div>
              </div>

              <p className="name">{userDetails?.name}</p>
              <p className="des">{userDetails?.designation}</p>

              <div className="id-mail">
                <p>{userDetails?.uid}</p>
                <p>{userDetails?.email}</p>
              </div>

              {checkPermissionExist(PASSWORD_CHANGE_PERMISSION) &&
                <div className="group-edit">
                  <span className="edit-btn mb-2" onClick={handleOpenChangePasswordModal}>
                    Change Password <PasswordKey />
                  </span>
                </div>}

            </div>

            <div className="group-functions">
              <div className="function-item">
                <h6>User Settings</h6>
                <div className="group-info-item">
                  <div className="text-detail">
                    <p> Inherited </p>
                    <div className="toggle-function">
                      <SimToggleSwitch checked={userDetails?.inherit} />
                    </div>
                  </div>
                  <p className="info-message"> Inherit all applications and resources from Parent Group</p>
                </div>
              </div>

              <div className="function-item">
                <div className="group-info-item">
                  <div className="text-detail">
                    <p> Total Applications </p>
                    <div className="text-output">
                      {userDetails?.count?.applications || 0}
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={toolTip({ text: `These are total application of ${userDetails?.name}` })}
                      >
                        <span>
                          <InfoIcon />
                        </span>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
                <div className="group-info-item">
                  <div className="text-detail">
                    <p> Total Resources </p>
                    <div className="text-output">
                      {userDetails?.count?.resources || 0}
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={toolTip({ text: `These are total resources of ${userDetails?.name}` })}
                      >
                        <span>
                          <InfoIcon />
                        </span>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="group-edit">
            <span className="edit-btn" onClick={handleOpenEditProfileModal}>
              Edit <EditIcon />
            </span>
            <p>
              USER SINCE:
              {userDetails?.createdAt && moment(userDetails?.createdAt).format("LL")}
            </p>
          </div>
        </div>
      ) : (
        <div className="team-infoMob">
          <div className="LogonInfo">
            <div className="logoWrapper user">
              {avatarSrc && !imageError ? (
                <img src={avatarSrc} referrerPolicy="no-referrer" onError={() => setImageError(true)} alt="avatar" />
              ) : (
                <span className="initials">{getPlaceholderName(userName)}</span>
              )}
            </div>
            <div className="infoWrapper">
              <span className="name">{userDetails.name}</span>

              <span className="des">{userDetails?.designation}</span>
              <span className="groupId">{userDetails?.email}</span>
            </div>
          </div>
          <div className="groupStats">
            <span className="statItem">
              <p>{userDetails?.count?.applications || 0}</p>
              <span> Total Applications </span>
            </span>
            <span className="statItem">
              <p>{userDetails?.count?.resources || 0}</p>
              <span> Total Resources </span>
            </span>
          </div>
          <span className="editIcon" onClick={handleOpenEditProfileModal}>
            Edit Profile
          </span>
        </div>
      )}
    </>
  );
};

export default UserInfoPanel;
